import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";

const Testimonials = () => {
  const [IsolionSpeaks, setTestimonials] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiIsoliansSpeaks", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setTestimonials(response.data.data);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  }, []);


  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Show 3 slides
    slidesToScroll: 0,
    vertical: true,
    centerMode: true,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  };

  return (
    <section className="testimonials">
        <div className="container-fluid">
            <div className="row">

           
      <div className="col-xs-4 col-sm-4 left-side">
        <div className="service-item">
          <div className="services-icon">
            <img
              src="/images/testimonials/speak-logo.png"
              alt="Isols Rising Leaders"
              width="60px"
              height="69px"
            />
          </div>
          <div className="services-text">
            <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">ISOLIANS SPEAK - Rising Leaders</h6>
            <p>Words of wisdom that make a difference.</p>
          </div>
        </div>
      </div>
      <div className="col-xs-8 col-sm-8 right-side">
        {IsolionSpeaks.length > 0 ? (
        <Slider {...settings}>
          {IsolionSpeaks.map((speak, index) => (
            <div  className="testimonial-item">
              <div className="quote-userpic">
                <img src={`https://www.isolsgroup.com/new/uploaded-images/testimonial/${speak.image}`} 
                alt={speak.heading} width="100px" height="100px" />
              </div>
              <div className="quote-content">
                <p className="quote-text">{speak.description.replace(/<[^>]+>/g, '')}</p>
                <p className="quote-author">{speak.heading}</p>
              </div>
            </div>
          ))}
        </Slider>
        ) : (
          <p className="text-center mt-4">No Isolion Data available.</p>
        )}
      </div>
      </div>
      </div>
    </section>
  );
};

export default Testimonials;
